import { API } from 'aws-amplify'

export const loadResultsSurveys = () => API.get('ResultsAPI', '/surveys', {})
